import customAxios from "./axiosConfig";
const PlantransactionService = {
    retrieve: function (pk) {
        var api_url = window.Urls['plantransaction-detail'](pk);
        return customAxios.get(api_url);
    },
    inititateAdyenPaymentSession: function (pk){
        var api_url = window.Urls['plantransaction_initiate_adyen_payment_session'](pk);
        return customAxios.post(api_url);
    },
    validate: function (data){
        var api_url = window.Urls['plantransaction_validate']();
        return customAxios.post(api_url, data);
    },
    initiateMultisafepaySession: function (pk, data){
        var api_url = window.Urls['plantransaction_initiate_multisafepay_payment_session'](pk);
        return customAxios.post(api_url, data);
    },
    getPaymentMethods: function(){
        var api_url = window.Urls['plantransaction_payment_methods']();
        return customAxios.get(api_url);
    }
};
export default PlantransactionService;